module.exports = __webpack_public_path__ + "static/media/BadgeTemplates-64.6f16e3dd.svg";